import React from 'react'
import classes from '../styles/style.module.css'
import getProfileImage from '../../../assets/Hooks/getProfileImage'

const HubblePudium = () => {
    return (
        <div className={classes.pudiumContainer}>
            <div className={classes.puduium}>
                <div className='row m-0 p-0 align-items-end'>
                    <div className='col-4 p-0'>
                        <div className={classes.pudiumElement}>
                            <div className={classes.profileImageContainer}>
                                {getProfileImage("")}
                            </div>
                            <p>علیرضا</p>
                            <div className={classes.scoreContainer}>3,570</div>
                            <img src='/images/hubble/3 c.png' alt='first place' />
                        </div>
                    </div>
                    <div className='col-4 p-0'>
                        <div className={classes.pudiumElement}>
                            <div className={classes.profileImageContainer}>
                                {getProfileImage("")}
                            </div>
                            <p>علیرضا</p>
                            <div className={classes.scoreContainer}>3,570</div>
                            <img src='/images/hubble/1 c.png' alt='first place' />
                        </div>
                    </div>
                    <div className='col-4 p-0'>
                        <div className={classes.pudiumElement}>
                            <div className={classes.profileImageContainer}>
                                {getProfileImage("")}
                            </div>
                            <p>علیرضا</p>
                            <div className={classes.scoreContainer}>3,570</div>
                            <img src='/images/hubble/2 c.png' alt='first place' />
                        </div>
                    </div>
                </div>
            </div>
            <div>
                <div className={classes.pudiumBottomFirst}></div>
                <div className={classes.pudiumBottomSecond}></div>
            </div>
        </div>
    )
}

export default HubblePudium